/**
 * Created by Stefann on 27/03/2019.
 */
import Branch from "@/lib/Branch";

export class Pack {
    public branch?: any;
    public moreComparisonInfo  = false;
    constructor(public id: number, public label: string, public premium: number, public splitting: any, public guarantees: any, public insurerName: string, public insurerLogo: string, public criteria: any = [], public packFile: any = [], public packAttributes: any = []) {
    }
}
